import React from 'react'
import { CustomTableBodyCell, CustomTableBodyRow, StyledCell } from './styles'

export const TableBodyComponent = ({ prepareRow, rows, columns, isScrollable }) => {
  const columnsTotalWidth = columns.reduce((a, c) => a + c.width, 0)
  return rows.map((row) => prepareRow(row) || (
    <CustomTableBodyRow {...row.getRowProps()}>
      {row.cells.map((cell) => (
        <CustomTableBodyCell
          {...cell.getCellProps()}
          className={cell.column.className}
          cellwidth={
                isScrollable
                  ? `${cell.column.width}px`
                  : '100%'
              }
        >
          <StyledCell>{cell.render('Cell')}</StyledCell>
        </CustomTableBodyCell>
      ))}
    </CustomTableBodyRow>
  ))
}
